import { defineStore } from 'pinia';
import { reactive } from 'vue';
import { apiClient } from '@/apis';

const dataStore = defineStore('data', () => {
  const kakaoProfiles = reactive({
    init: false,
    list: [],
  });

  const departments = reactive({
    init: false,
    list: [],
  });

  const organizationInfo = reactive({
    init: false,
    name: '',
    company: '',
    serviceName: '',
  });

  const getAllKakaoProfiles = () => new Promise((resolve, reject) => {
    let page = 0;
    const kakaoProfileList = [];

    const getApi = () => {
      apiClient.get('/kakao-profile', { params: { page } })
        .then((response) => {
          response.dataList.forEach?.(({ id, name }) => {
            kakaoProfileList.push({
              label: name,
              value: id,
            });
          });

          departments.list = response.dataList.map?.(({ id, name }) => ({
            label: name,
            value: id,
          })) ?? [];

          if (response.total === kakaoProfileList.length) {
            resolve(kakaoProfileList);
            return;
          }

          page += 1;
          getApi();
        })
        .catch((error) => {
          reject(error);
        });
    };

    getApi();
  });

  const getKakaoProfiles = () => {
    if (kakaoProfiles.init) {
      return kakaoProfiles;
    }

    getAllKakaoProfiles()
      .then((list) => {
        kakaoProfiles.list = list;
        kakaoProfiles.init = true;
      })
      .catch((error) => {
        console.error(error);
      });

    return kakaoProfiles;
  };

  const getAllDepartments = () => new Promise((resolve, reject) => {
    let page = 0;
    const departmentsList = [];

    const getApi = () => {
      apiClient.get('/departments', { params: { page } })
        .then((response) => {
          response.dataList.forEach?.(({ id, name }) => {
            departmentsList.push({
              label: name,
              value: id,
            });
          });

          departments.list = response.dataList.map?.(({ id, name }) => ({
            label: name,
            value: id,
          })) ?? [];

          if (response.total === departmentsList.length) {
            resolve(departmentsList);
            return;
          }

          page += 1;
          getApi();
        })
        .catch((error) => {
          reject(error);
        });
    };

    getApi();
  });

  const getDepartments = () => {
    if (departments.init) {
      return departments;
    }

    getAllDepartments()
      .then((list) => {
        departments.list = list;
        departments.init = true;
      })
      .catch((error) => {
        console.error(error);
      });

    apiClient.get('/departments', { params: { page: 0 } })
      .then((response) => {
        departments.list = response.dataList.map?.(({ id, name }) => ({
          label: name,
          value: id,
        })) ?? [];

        departments.init = true;
      })
      .catch((error) => {
        console.error(error);
      });

    return departments;
  };

  let getUserInfoPromise;

  const getUserInfo = async () => {
    if (getUserInfoPromise) {
      return getUserInfoPromise;
    }

    getUserInfoPromise = apiClient.get('/users')
      .finally(() => {
        getUserInfoPromise = null;
      });

    return getUserInfoPromise;
  };

  const getOrganizationInfo = () => {
    if (organizationInfo.init) {
      return organizationInfo;
    }

    getUserInfo()
      .then((response) => {
        const {
          name,
          organizationName,
          serviceName,
        } = response;

        organizationInfo.init = true;
        organizationInfo.name = name;
        organizationInfo.company = organizationName;
        organizationInfo.serviceName = serviceName;
      })
      .catch((error) => {
        console.error(error);
      });

    return organizationInfo;
  };

  const setOrganizationInfo = ({
    name,
    company,
    serviceName,
  }) => {
    organizationInfo.init = true;
    organizationInfo.name = name;
    organizationInfo.company = company;
    organizationInfo.serviceName = serviceName;
  };

  const resetOrganizationInfo = () => {
    kakaoProfiles.init = false;
    kakaoProfiles.list = [];
    departments.init = false;
    departments.list = [];
    organizationInfo.init = false;
    organizationInfo.name = '';
    organizationInfo.company = '';
    organizationInfo.serviceName = '';
  };

  return {
    getKakaoProfiles,
    getDepartments,
    getOrganizationInfo,
    getUserInfo,
    setOrganizationInfo,
    resetOrganizationInfo,
  };
});

export default dataStore;
